export function compareText(first?: string | null, second?: string | null): number {
  return (first ?? '').localeCompare(second ?? '');
}

export function compareDate(first?: string | null, second?: string | null): number {
  return new Date(first ?? 0).getTime() - new Date(second ?? 0).getTime();
}
